"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefaultClassifierAdminPages = void 0;
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const CountyAdminPage_1 = require("../components/CountyAdminPage");
const EthnicityAdminPage_1 = require("../components/EthnicityAdminPage");
const GenderAdminPage_1 = require("../components/GenderAdminPage");
const JurisdictionAdminPage_1 = require("../components/JurisdictionAdminPage");
const RegionAdminPage_1 = require("../components/RegionAdminPage");
const StateAdminPage_1 = require("../components/StateAdminPage");
const TerritoryAdminPage_1 = require("../components/TerritoryAdminPage");
function useDefaultClassifierAdminPages() {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    // please keep this list sorted
    return [
        {
            label: t('defaultClassifiers.county'),
            name: 'county',
            path: 'county',
            groupLabel: t('defaultClassifiers.stateLevel'),
            component: CountyAdminPage_1.CountyAdminPage,
        },
        {
            label: t('defaultClassifiers.ethnicity'),
            name: 'ethnicity',
            path: 'ethnicity',
            groupLabel: t('defaultClassifiers.personalInformation'),
            component: EthnicityAdminPage_1.EthnicityAdminPage,
        },
        {
            label: t('defaultClassifiers.gender'),
            name: 'gender',
            path: 'gender',
            groupLabel: t('defaultClassifiers.personalInformation'),
            component: GenderAdminPage_1.GenderAdminPage,
        },
        {
            label: t('defaultClassifiers.jurisdiction'),
            name: 'jurisdiction',
            path: 'jurisdiction',
            groupLabel: t('defaultClassifiers.stateLevel'),
            component: JurisdictionAdminPage_1.JurisdictionAdminPage,
        },
        {
            label: t('defaultClassifiers.region'),
            name: 'region',
            path: 'region',
            groupLabel: t('defaultClassifiers.stateLevel'),
            component: RegionAdminPage_1.RegionAdminPage,
        },
        {
            label: t('defaultClassifiers.state'),
            name: 'state',
            path: 'state',
            groupLabel: t('defaultClassifiers.stateLevel'),
            component: StateAdminPage_1.StateAdminPage,
        },
        {
            label: t('defaultClassifiers.territory'),
            name: 'territory',
            path: 'territory',
            groupLabel: t('defaultClassifiers.stateLevel'),
            component: TerritoryAdminPage_1.TerritoryAdminPage,
        },
    ];
    // please keep this list sorted
}
exports.useDefaultClassifierAdminPages = useDefaultClassifierAdminPages;
